import { get } from 'lodash'
export const isSlateActive = (integrations) => get(integrations, 'Slate.Status', '') === 'Live'
export const isAPIActive = (integrations) => get(integrations, 'API.Status', '') === 'Live'
export const SLATE_SFTP_DOMAIN = 'ft.technolutions.net'
export const isSFTPSlate = (integrations) => get(integrations, 'SFTP.Credentials.Host', '') === SLATE_SFTP_DOMAIN
export const isSFTPActive = (integrations) => get(integrations, 'SFTP.Status', '') === 'Live'
export const isDownload = (integrations) =>
  !isSFTPActive(integrations) && !isAPIActive(integrations) && !isSlateActive(integrations)
